<template>
  <div
    :style="[
      $vuetify.breakpoint.xs ? { padding: '30px' } : { padding: '50px' },
    ]"
    id="classroom"
  >
    <b-overlay :show="process" no-wrap>
      <template v-slot:overlay>
        <img
          src="../assets/images/logo anim.svg"
          width="100px"
          height="100px"
        />
      </template>
    </b-overlay>
    <b-overlay :show="confirm" no-wrap id="confirmComplete" fixed>
      <template v-slot:overlay>
        <div class="text-center p-3" style="position: relative; top: -0px">
          <p>
            <strong id="form-confirm-label"
              >Are you sure you want to delete this post?</strong
            >
          </p>
          <div class="d-flex justify-content-center">
            <b-button
              variant="outline-danger"
              class="mr-3"
              @click="confirm = false"
              >Cancel</b-button
            >
            <b-button
              variant="outline-success"
              class="ml-3"
              @click="
                confirm = false;
                deletePost();
              "
              >Yes</b-button
            >
          </div>
        </div>
      </template>
    </b-overlay>
    <b-modal centered v-model="modalShow" title="Rate Teacher">
      <b-form-group
        label="Enter your rating:"
        description="The feedback you give is anonymous."
      >
        <b-form-rating variant="warning" v-model="rating"></b-form-rating>
      </b-form-group>
      <b-form-group
        label="Comments:"
        description="Be as descriptive as possible."
      >
        <b-form-textarea
          v-model="comments"
          rows="3"
          no-resize
        ></b-form-textarea>
      </b-form-group>
      <template v-slot:modal-footer>
        <b-button variant="success" @click="rateTeacher()">Submit</b-button>
      </template>
    </b-modal>
    <b-modal
      centered
      scrollable
      v-model="showDeets"
      size="lg"
      title="Student Details"
    >
      <table class="table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Parent's Email</th>
            <th>School</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="stud in studentData" v-bind:key="stud.email">
            <td>{{ stud.name }}</td>
            <td>{{ stud.email }}</td>
            <td>{{ stud.parentEmail }}</td>
            <td>{{ stud.school }}</td>
          </tr>
        </tbody>
      </table>
      <template v-slot:modal-footer>
        <div style="display: none"></div>
      </template>
    </b-modal>
    <b-modal
      centered
      scrollable
      v-model="showFeedbacks"
      size="lg"
      title="Student Feedbacks"
    >
      <table class="table">
        <thead>
          <tr>
            <th>Student</th>
            <th>Rating</th>
            <th>Comments</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="feedback in feedbacks" v-bind:key="feedback.comments">
            <td>{{ feedback.student }}</td>
            <td>{{ feedback.rating }}</td>
            <td>{{ feedback.comments }}</td>
          </tr>
        </tbody>
      </table>
      <template v-slot:modal-footer>
        <div style="display: none"></div>
      </template>
    </b-modal>
    <div v-if="noAuth">You are not authorised to view this page.</div>
    <div v-else style="display: flex; flex-direction: column">
      <div style="display: flex; justify-content: space-between">
        <h4>{{ $route.params.class }}</h4>
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn outlined small v-bind="attrs" v-on="on">Actions</v-btn>
          </template>

          <v-list>
            <v-list-item
              :to="{ name: 'Assignment List' }"
              style="text-decoration: none"
              >Go to Assignments</v-list-item
            >
            <v-list-item
              :to="{ name: 'Resources' }"
              style="text-decoration: none"
              >Go to Resources</v-list-item
            >

            <v-list-item v-if="teacher" @click="studentDeets()"
              >View Student Details</v-list-item
            >
            <v-list-item
              v-if="classTeacher || admin"
              @click="studentFeedbacks()"
              >View Student Feedbacks</v-list-item
            >
          </v-list>
        </v-menu>
      </div>
      <v-container>
        <v-row>
          <v-col cols="12" sm="5" v-if="classTeacher">
            <b-card title="Add Post">
              <vue-editor
                v-model="content"
                :editorToolbar="toolbar"
              ></vue-editor>
              <b-button
                size="sm"
                class="float-right mt-3"
                variant="outline-success"
                @click="submitPost()"
                >Submit</b-button
              >
            </b-card>
          </v-col>
          <v-col cols="12" sm="4" v-if="!teacher">
            <b-card
              v-for="teacher in classDeets.teachers"
              :key="teacher"
              border-variant="primary"
              header="Teacher"
              header-bg-variant="primary"
              header-text-variant="white"
              align="center"
            >
              <div
                style="
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  justify-content: center;
                "
              >
                <b-avatar
                  size="3rem"
                  :src="classDeets.userData[teacher].profilePicUrl"
                  style="object-fit: cover"
                  class="mr-4"
                  v-if="showAvatar"
                ></b-avatar>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    font-size: 9pt;
                    align-text: center;
                  "
                >
                  <div>{{ classDeets.userData[teacher].name }}</div>
                  <div>{{ teacher }}</div>
                  <div
                    @click="
                      teacherSel = teacher;
                      modalShow = !modalShow;
                    "
                    style="color: blue; cursor: pointer"
                  >
                    Rate Teacher
                  </div>
                </div>
              </div>
            </b-card>
          </v-col>
          <v-col>
            <b-card
              v-for="post in posts"
              class="mb-3"
              :key="post.text"
              header-tag="header"
            >
              <template v-slot:header>
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  "
                >
                  <div
                    style="
                      display: flex;
                      flex-direction: row;
                      align-items: center;
                    "
                  >
                    <b-avatar
                      :src="classDeets.userData[post.author].profilePicUrl"
                      style="object-fit: cover"
                    ></b-avatar>
                    <div class="ml-3">
                      <div>{{ classDeets.userData[post.author].name }}</div>
                      <div>{{ post.createdAt | fromNow }}</div>
                    </div>
                  </div>
                  <b-icon-x
                    scale="1.2"
                    v-if="classTeacher"
                    @click="
                      potDelete = post;
                      confirm = true;
                    "
                  ></b-icon-x>
                </div>
              </template>
              <b-card-text
                style="margin-bottom: -15px"
                v-html="post.text"
              ></b-card-text>
            </b-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
// TODO 2 report modal (after template work)

const fb = require("../firebaseConfig.js");
import { mapState } from "vuex";
import moment from "moment";
import { VueEditor } from "vue2-editor";

export default {
  components: {
    VueEditor,
  },
  data() {
    return {
      showAvatar: false,
      toolbar: ["bold", "link", "image"],
      modalShow: false,
      studentData: [],
      showFeedbacks: false,
      feedbacks: [],
      showDeets: false,
      teacherSel: "",
      rating: 0,
      comments: "",
      posts: [],
      process: true,
      promises: [],
      noAuth: true,
      classDeets: "",
      classId: "",
      classTeacher: false,
      content: "",
      confirm: false,
      potDelete: null,
    };
  },
  created: async function () {
    await this.promise;
    await this.rolePromise;
    const vue = this;
    if (vue.teacher) {
      await fb.classesCollection
        .where("name", "==", vue.$route.params.class)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            vue.noAuth = false;
            vue.classId = doc.id;
            vue.classDeets = doc.data();
          });
        });
    } else {
      await fb.classesCollection
        .where("students", "array-contains", fb.auth.currentUser.email)
        .where("name", "==", vue.$route.params.class)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            vue.noAuth = false;
            vue.classId = doc.id;
            vue.classDeets = doc.data();
          });
        });
    }
    await fb.db
      .collection("classes")
      .doc(this.classId)
      .collection("posts")
      .orderBy("createdAt", "desc")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          this.posts.push(doc.data());
        });
      });
    if (this.classDeets.teachers.includes(this.currentUser.email)) {
      this.classTeacher = true;
    }
    this.process = false;
  },
  computed: {
    ...mapState([
      "admin",
      "teacher",
      "rolePromise",
      "currentUser",
      "userProfile",
      "promise",
    ]),
  },
  mounted: function () {
    if (window.innerWidth > 900) {
      this.showAvatar = true;
    }
  },
  methods: {
    deletePost() {
      fb.db
        .collection("classes")
        .doc(this.classId)
        .collection("posts")
        .where("createdAt", "==", this.potDelete.createdAt)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            fb.db
              .collection("classes")
              .doc(this.classId)
              .collection("posts")
              .doc(doc.id)
              .delete()
              .then(() => {
                const index = this.posts.indexOf(this.potDelete);
                this.posts.splice(index, 1);
              });
          });
        });
    },
    makeToast(type, msg) {
      switch (type) {
        case "err":
          var variant = "danger";
          var title = "Error";
          break;
        case "suc":
          var variant = "success";
          var title = "Success";
          break;
      }
      this.$bvToast.toast(msg, {
        title: title,
        variant: variant,
        solid: true,
      });
    },
    studentDeets() {
      if (this.studentData.length != 0) {
        this.showDeets = true;
        return;
      }
      fb.db
        .collection("users")
        .where("classes", "array-contains", this.$route.params.class)
        .where("type", "==", "student")
        .orderBy("name")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.studentData.push({
              name: doc.data().name,
              email: doc.data().email,
              parentEmail: doc.data().parentEmail,
              school: doc.data().school,
            });
          });
        })
        .then(() => {
          this.showDeets = true;
        });
    },
    studentFeedbacks() {
      if (this.feedbacks.length != 0) {
        this.showFeedbacks = true;
        return;
      }
      fb.db
        .collection("feedbacks")
        // .where("teacher", "==", this.currentUser.email)
        .where("class", "==", this.$route.params.class)
        .orderBy("timestamp", "desc")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.feedbacks.push(doc.data());
          });
        })
        .then(() => {
          this.showFeedbacks = true;
        });
    },
    submitPost() {
      if (!this.content) {
        this.makeToast("err", "Empty text field");
      }
      const userEmail = fb.auth.currentUser.email;
      fb.db
        .collection("classes")
        .doc(this.classId)
        .collection("posts")
        .add({
          text: this.content,
          author: userEmail,
          createdAt: fb.firebase.firestore.Timestamp.now(),
        })
        .then((docRef) => {
          fb.db.collection("classes").doc(this.classId).update({
            lastUpdated: fb.firebase.firestore.Timestamp.now(),
          });
          fb.db
            .collection("classes")
            .doc(this.classId)
            .collection("posts")
            .doc(docRef.id)
            .get()
            .then((doc) => {
              this.posts.unshift(doc.data());
              this.content = "";
            });
        });
    },
    async rateTeacher() {
      let limitReached = false;
      //Multiple teachers and classes with duration greater than a year not accounted for
      await fb.db
        .collection("feedbacks")
        .where("student", "==", this.currentUser.email)
        .where("class", "==", this.$route.params.class)
        .orderBy("timestamp", "desc")
        .limit(1)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const today = new Date();
            const timestamp = doc.data().timestamp.toDate();
            if (
              today.getDate() === timestamp.getDate() &&
              today.getMonth() === timestamp.getMonth()
            ) {
              limitReached = true;
            }
          });
        });
      if (limitReached) {
        this.modalShow = false;
        this.comments = "";
        this.rating = 0;
        this.makeToast(
          "err",
          "You can only give one feedback for a teacher per day"
        );
        return;
      }
      if (this.rating == 0) {
        this.makeToast("err", "Select a rating");
        return;
      }
      fb.db
        .collection("feedbacks")
        .add({
          teacher: this.teacherSel,
          student: this.currentUser.email,
          rating: this.rating,
          class: this.$route.params.class,
          comments: this.comments,
          timestamp: fb.firebase.firestore.Timestamp.now(),
        })
        .then((docRef) => {
          this.makeToast("suc", "Successfully submitted rating");
        });
      this.modalShow = false;
      (this.comments = ""), (this.rating = 0);
    },
  },
  filters: {
    fromNow(a) {
      return moment(a.toMillis()).fromNow();
    },
  },
};
</script>